import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { QbItaGenericErrorComponent } from '@fwmovilidad/qb-home-ita-components-lib';

@Injectable({
  providedIn: 'root',
})
export class GenericErrorModalService {
  private seenInd = false;
  constructor(private readonly modalCtrl: ModalController) {}

  async showUnexpectedErrorModal(): Promise<void> {
    if (!this.seenInd) {
      this.seenInd = true;
      this.modalCtrl
        .create({
          component: QbItaGenericErrorComponent,
          componentProps: {
            isModal: true,
            titleText: 'ERROR_PAGE.TITLE',
            btnLabel: 'ERROR_PAGE.BUTTON',
            iconClose: 'verti-close-16',
          },
        })
        .then((modal: HTMLIonModalElement): void => {
          modal.present();
          modal.onDidDismiss().then(({ data }) => {
            this.seenInd = false;
          });
        });
    }
  }
}
